import SiteConfiguration from '../pages/admin/siteConfiguration'
import SMSCredits from '../pages/admin/smsHistory/SMSCredits'
import SMSHistory from '../pages/admin/smsHistory/SMSHistory'

export default [
  { path: '/site-configuration/*', element: <SiteConfiguration />, title: 'Site Configuration' },
  { path: '/sms-history', element: <SMSHistory />, title: 'SMS History' },
  { path: '/sms-credits', element: <SMSCredits />, title: 'SMS Credits' },
]
